// FurClean — scripts globales (vanilla, sin librerias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initAcordeon();
  initGaleriaProducto();
  initSelectorVariantes();
  initComparador();
});

function initReveal() {
  var els = document.querySelectorAll('.fc-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('.fc-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.getAttribute('data-target') || el.textContent) || 0;
      var decimals = (el.getAttribute('data-decimals') || '0') | 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initAcordeon() {
  var grupos = document.querySelectorAll('[data-fc-acordeon]');
  grupos.forEach(function (grupo) {
    var items = grupo.querySelectorAll('[data-fc-acordeon-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-fc-acordeon-btn]');
      var panel = item.querySelector('[data-fc-acordeon-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('fc-abierto');
        items.forEach(function (i) {
          i.classList.remove('fc-abierto');
          var p = i.querySelector('[data-fc-acordeon-panel]');
          if (p) p.style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('fc-abierto');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-fc-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-fc-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-fc-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('fc-activo'); });
        mini.classList.add('fc-activo');
      });
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-fc-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-fc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-fc-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-fc-precio]');
    var compareEl = form.querySelector('[data-fc-precio-comparado]');
    var botonAdd = form.querySelector('[data-fc-add]');

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.precioFormateado;
      if (compareEl) {
        if (match.compareFormateado) {
          compareEl.textContent = match.compareFormateado;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (botonAdd) {
        botonAdd.disabled = !match.disponible;
        botonAdd.textContent = match.disponible ? botonAdd.getAttribute('data-texto-disponible') : botonAdd.getAttribute('data-texto-agotado');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initComparador() {
  var comparadores = document.querySelectorAll('[data-fc-comparador]');
  comparadores.forEach(function (comp) {
    var handle = comp.querySelector('[data-fc-comparador-handle]');
    var despues = comp.querySelector('[data-fc-comparador-despues]');
    if (!handle || !despues) return;
    var arrastrando = false;

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      despues.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      mover(e.clientX);
    });
    handle.addEventListener('pointerup', function () { arrastrando = false; });
    comp.addEventListener('click', function (e) {
      if (e.target === handle) return;
      mover(e.clientX);
    });
  });
}
